import React, { Component, createRef } from 'react';
import { activationPage } from '../../../global/texts/postActivation/activation';
import TextField from '../../../components/Textfield/TextField';
import Button from '../../../components/Button/Button';
import { CircularProgress } from '@material-ui/core';
import * as ActivationAction from '../../../store/Activation/actions';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { store } from 'react-notifications-component';
import BackButton from '../../../Assets/images/commonImages/backButton.svg';
import ProgressBar from 'react-bootstrap/ProgressBar';
import VisaIcon from '../../../Assets/images/Activation/visa.png';
import infoIcon from '../../../Assets/images/Activation/info.svg';
import simImage from '../../../Assets/images/Activation/simImage.svg';
import AmericanExpress from '../../../Assets/images/Activation/americanExpress.svg';
import TickMark from '../../../Assets/images/Activation/billingTick.png';
import AddIcon from '@material-ui/icons/Add';
import * as Action from '../../../store/Checkout/actions';
import * as BillingAction from '../../../store/Billing/actions';
// ---- HSD Changes ------
import * as HomeAction from '../../../store/HomePage/actions';
import dinersClub from '../../../Assets/images/dinersclub.png';
import amex from '../../../Assets/images/imgFiAmex.png';
import discoverImg from '../../../Assets/images/imgFiDiscover.png';
import visa from '../../../Assets/images/imgFiVisa.png';
import mastercard from '../../../Assets/images/mastercard.png';
// import { pushTrackingEventsToGAAndFB } from '../../../global/commonFunctions/GaAndFb';

import SetupProfileSteps from '../../../components/SetupProfileSteps/SetupProfileSteps';
import successIcon from '../../../Assets/images/Activation/success.svg';
import inProgressIcon from '../../../Assets/images/Activation/inProgress.svg';
import failedIcon from '../../../Assets/images/Activation/failed.svg';
import { isHSDEnabled, isPaymentEnabled } from '../../../config';
import GenericError from '../../../components/GenericError/GenericError';
// import ActivationStatus from '../../../components/ActivationStatusComponent/ActivationStatus';
// ---- HSD Changes ------
// import Skeleton from 'react-loading-skeleton';
// import { pushTrackingEventsToGAAndFBNew } from '../../../global/commonFunctions/GaAndFb';
import TagManager from 'react-gtm-module';
import * as TrackOrderAction from '../../../store/TrackOrder/actions';
import { getUserName } from '../../../global/commonFunctions/getUserName';

type initialProps = {
    history: any;
    ActivationActions: any;
    ActivationState: any;
    changeCurrentPage: any;
    CheckoutActions: any;
    CheckoutState: any;
    BillingActions: any;
    BillingState: any;
    // ---- HSD Changes ------
    HomeState: any;
    HomeActions: any;
    PostActivationState: any;
    TrackOrderActions: any;
    TrackOrderState: any;
};
type initialState = {
    simNo: string;
    nextClicked: boolean;
    user: any;
    error: boolean;
    simModal: boolean;
    autopayCard: any;
    changeCard: boolean;
    removeModal: boolean;
    updateModal: boolean;
    setDefaultModal: boolean;
    uuid: any;
    updatedExpiry: string;
    updateError: string;
    activationPause: boolean;
    activationPauseAmount: any;
    // config: any;
    buttonLoading: boolean;
    amount: any;
    modalLoading: boolean;
    confirmClicked: boolean;
    plan: any;
    payNowModal: boolean;
    payNowSuccess: boolean;
    paySucessActivationFail: boolean;
    payNowFail: boolean;
    mainPageModal: boolean;
    email: string;
    eSim: boolean;
    confirmed: boolean;
    ios: boolean;
    android: boolean;
    resendModal: boolean;
    kitSent: boolean;
    showSetupProfileModal: boolean;
    paymentSuccessModal: boolean;
    activationSteps: boolean;
    orderSummary: boolean;
    currentUser: any;
    loader: boolean;
    actInProgress: boolean;
    actFailed: boolean;
    actSuccess: boolean;
    portInProgress: boolean;
    invalidSim: boolean;
    isPortFailed: boolean;
    isPortingCase: boolean;
    statusPassword: any;
    fromPorting: any;
    genericErr: boolean;
    isActivationGenericErr: boolean;
    setExistingPrice: number;
    // setTotalPrice: number;
    totalActiveLines: number;
    // ---- HSD Changes ------
    isHsdCustomer: boolean;
    isSecondaryCust: boolean;
    hsdDiscount: number;
    priceLoader: boolean;
    currentPlan: any;
};
const cardImages: Record<string, string> = {
    VISA: visa,
    MASTERCARD: mastercard,
    'AMERICAN EXPRESS': amex,
    'DINERS CLUB': dinersClub,
    DISCOVER: discoverImg,
    AMERICANEXPRESS: amex,
    DINERSCLUB: dinersClub,
};
export class Step3 extends Component<initialProps, initialState> {
    private formRef: React.RefObject<HTMLFormElement>;
    constructor(props: initialProps) {
        super(props);
        this.formRef = createRef<HTMLFormElement>();
    }
    state: initialState = {
        simNo: '',
        nextClicked: false,
        user: null,
        error: false,
        simModal: false,
        autopayCard: null,
        changeCard: false,
        removeModal: false,
        updateModal: false,
        setDefaultModal: false,
        uuid: null,
        updatedExpiry: '',
        updateError: '',
        activationPause: false,
        activationPauseAmount: null,
        // config: null,
        buttonLoading: false,
        amount: {
            totalAmount: 0,
            taxes: 0,
        },
        plan: null,
        modalLoading: false,
        confirmClicked: false,
        payNowModal: false,
        payNowSuccess: false,
        paySucessActivationFail: false,
        payNowFail: false,
        mainPageModal: false,
        email: '',
        eSim: false,
        confirmed: false,
        ios: true,
        android: false,
        resendModal: false,
        kitSent: false,
        showSetupProfileModal: false,
        paymentSuccessModal: false,
        activationSteps: false,
        orderSummary: false,
        currentUser: '',
        loader: false,
        actFailed: false,
        actInProgress: false,
        actSuccess: false,
        portInProgress: false,
        invalidSim: false,
        isPortFailed: false,
        isPortingCase: false,
        statusPassword: '',
        fromPorting: '',
        genericErr: false,
        isActivationGenericErr: false,
        setExistingPrice: 0,
        // setTotalPrice: 0,
        totalActiveLines: 0,
        // ---- HSD Changes ------
        isHsdCustomer: false,
        isSecondaryCust: false,
        hsdDiscount: 0,
        priceLoader: false,
        currentPlan: null,
    };

    componentDidMount() {
        let customerDetails: any = localStorage.getItem('customerDetail');
        customerDetails = JSON.parse(customerDetails);
        let totalLines = customerDetails.secondaryCustomers.length;
        this.setState({ totalActiveLines: totalLines });
        let currentPlan: any = null;
        currentPlan = localStorage.getItem('currentPlan');
        currentPlan = JSON.parse(currentPlan);
        if (currentPlan === null) {
            currentPlan = localStorage.getItem('reachSelectedPlanDetail');
            currentPlan = JSON.parse(currentPlan);
            currentPlan = currentPlan?.plan;
        }
        this.setState({
            currentPlan: currentPlan,
        });
        //existing Price and Total price
        const existingPrice = this.handleChangePlanPrice(currentPlan, totalLines);
        // const newPrice = this.handleChangePlanPrice(currentPlan, totalLines);
        this.setState({ setExistingPrice: existingPrice });
        // this.setState({ setTotalPrice: newPrice });

        this.props.HomeActions.reachPlans();
        let customerDetail: any = localStorage.getItem('customerDetail');
        customerDetail = JSON.parse(customerDetail);
        window.scroll(0, 0);
        let secondaryCustomer: any = localStorage.getItem('secondaryCustomerDetail');
        let fromPorting: any = localStorage.getItem('fromPorting');
        if (fromPorting) {
            fromPorting = JSON.parse(fromPorting);
            this.setState({ fromPorting });
        }
        if (
            customerDetail.status === 1 ||
            customerDetail.status === 8 ||
            customerDetail.status === 9 ||
            customerDetail.status === 10
        ) {
            this.props.ActivationActions.activationStatus({
                customerId: customerDetail && customerDetail.id,
            });
        }
        if (secondaryCustomer) {
            secondaryCustomer = JSON.parse(secondaryCustomer);
            this.setState({
                eSim: secondaryCustomer.esim,
                currentUser: secondaryCustomer,
                // ---- HSD Changes ------
                isSecondaryCust: true,
            });
            if (secondaryCustomer.esim) {
                this.setState({ orderSummary: true });
                // store.addNotification({
                //     message: `${secondaryCustomer?.firstName}'s line is activated and your Digital Activation Kit will reach your inbox on ${secondaryCustomer?.emailId}.`,
                //     type: 'info',
                //     insert: 'top',
                //     container: 'top-full',
                //     animationIn: ['animate__animated', 'animate__fadeIn'],
                //     animationOut: ['animate__animated', 'animate__fadeOut'],
                //     dismiss: {
                //         duration: 5000,
                //         showIcon: true,
                //     },
                //     id: 'activatedEsimNoti',
                // });
            }
        } else {
            if (customerDetail) {
                this.setState({
                    eSim: customerDetail.esim,
                    currentUser: customerDetail,
                    // ---- HSD Changes ------
                    isSecondaryCust: false,
                });
                if (customerDetail.esim) {
                    this.setState({ orderSummary: true });
                }
            }
        }
        this.setState({
            user: customerDetail,
            // ---- HSD Changes ------
            isHsdCustomer: customerDetail?.hsdPlan,
        });
        let simId = localStorage.getItem('simId');
        let manageCard = localStorage.getItem('manageCard');

        let currentuser: any = localStorage.getItem('currentuser');
        currentuser = JSON.parse(currentuser);
        // ---- HSD Changes ------
        if (customerDetail?.hsdPlan && isHSDEnabled) {
            this.setState({ priceLoader: true });
        }
        if (customerDetail && customerDetail.isPrimary && customerDetail.status === 2) {
            this.props.BillingActions.userPlans({ customerId: customerDetail?.id });
        } else {
            this.props.TrackOrderActions.reachPlan({
                plan: customerDetail && customerDetail.reachPlanId,
            });
        }
        if (
            this.props.ActivationState &&
            this.props.ActivationState.getCC &&
            this.props.ActivationState.getCC.status === 'SUCCESS' &&
            this.props.ActivationState.getCC.data &&
            this.props.ActivationState.getCC.data.length > 0
        ) {
            this.props.ActivationState.getCC.data.map((el: any) => {
                if (el.isAutoPay) {
                    this.setState({ autopayCard: el });
                    return null;
                } else {
                    return null;
                }
            });
        } else {
            isPaymentEnabled && this.props.ActivationActions.getCC({ customerId: customerDetail && customerDetail.id });
        }
        if (manageCard === 'true') {
            this.setState({ changeCard: true });
        } else if (simId) {
            this.setState({ simNo: simId });
        }
        this.removeAllTickers();
    }

    componentWillUnmount() {
        this.removeAllTickers();
    }

    removeAllTickers() {
        store.removeNotification('activationSimCardSuccess');
        store.removeNotification('activationSimCardInvalid');
        store.removeNotification('activationSimCardFail');
        store.removeNotification('activationCardExpiryUpdated');
        store.removeNotification('activationCardSetAsDefault');
        store.removeNotification('activationCardDeleted');
        store.removeNotification('activationCardHoldFail');
        store.removeNotification('activationCardAutopayFail');
        store.removeNotification('activationCardRemoveFail');
        store.removeNotification('sendKitSuccess');
        store.removeNotification('activatedEsimNoti');
    }

    handleChangePlanPrice = (plan: any, totalLines: any) => {
        if (!plan.addLineSplitPrice) {
            return plan.baseLinePrice + totalLines * plan.additionalLinePrice;
        } else {
            const addLinePrice = plan.addLineSplitPrice;
            if (totalLines > 1) {
                let newPrice = 0;
                for (let i = 1; i <= totalLines - 1; i++) {
                    newPrice = newPrice + addLinePrice[i];
                }
                return plan.baseLinePrice + newPrice - this.state.hsdDiscount * totalLines;
            } else {
                return plan.baseLinePrice;
            }
        }
    };

    async componentDidUpdate(prevProps: initialProps) {
        const prev = prevProps && prevProps.ActivationState;
        const cur = this.props && this.props.ActivationState;
        let step3 = activationPage && activationPage.step3;
        let prevOne = prevProps && prevProps.CheckoutState;
        let curOne = this.props && this.props.CheckoutState;
        // ---- HSD Changes ------
        const prevH = prevProps && prevProps.HomeState;
        const curH = this.props && this.props.HomeState;

        // const prevB = prevProps && prevProps.BillingState;
        // const curB = this.props && this.props.BillingState;
        // const prev1 = prevProps && prevProps.TrackOrderState;
        // const cur1 = this.props && this.props.TrackOrderState;
        let userDataObj: any = localStorage.getItem('customerDetail');
        userDataObj = JSON.parse(userDataObj);

        let secondaryCustomer: any = localStorage.getItem('secondaryCustomerDetail');
        secondaryCustomer = JSON.parse(secondaryCustomer);
        let customerDetail: any = localStorage.getItem('customerDetail');
        customerDetail = JSON.parse(customerDetail);
        if (
            prevOne.getCustomer !== curOne.getCustomer &&
            curOne.getCustomer &&
            curOne.getCustomer.status === 'SUCCESS' &&
            curOne.getCustomer.data
        ) {
            if (curOne.getCustomer.data.status !== 2) {
                this.props.ActivationActions.activationStatus({
                    customerId: userDataObj && userDataObj.id,
                });
            } else {
                this.setState({ actSuccess: true, actInProgress: false });
            }
        }

        // ---- HSD Changes ------
        // if (
        //     prevB.userPlans !== curB.userPlans &&
        //     curB.userPlans &&
        //     curB.userPlans.data
        // ) {
        //     if(isHSDEnabled) {
        //         // this.props.CheckoutActions.Coupon({
        //         //     couponCode: curB.userPlans.data?.wowCoupon,
        //         // });
        //         // this.setState({
        //         //     priceLoader: true,
        //         // });
        //     }
        // }

        if (prevH.plans !== curH.plans && curH.plans && curH.plans.status === 'SUCCESS' && curH.plans.data) {
            if (customerDetail?.hsdPlan && isHSDEnabled) {
                let couponName: any = null;
                curH.plans.data.map((el: any) => {
                    if (el.name === this.state.currentPlan.name && el.wowCoupon) {
                        couponName = el.wowCoupon;
                    }
                });
                this.state.isHsdCustomer &&
                    customerDetail?.hsdPlan &&
                    isHSDEnabled &&
                    this.props.CheckoutActions.Coupon({
                        couponCode: couponName,
                    });
                this.setState({
                    priceLoader: true,
                });
            }
        }
        if (
            prevOne.coupon !== curOne.coupon &&
            curOne.coupon &&
            curOne.coupon.status === 'SUCCESS' &&
            curOne.coupon.data
        ) {
            if (this.state.isHsdCustomer) {
                this.setState({
                    hsdDiscount: this.state.isSecondaryCust
                        ? curOne.coupon?.data?.secondaryDiscountInDollar
                        : curOne.coupon?.data?.discountInDollar,
                    priceLoader: false,
                });
            }
        }
        if (
            prevOne.errorCoupon !== curOne.errorCoupon &&
            curOne.errorCoupon &&
            curOne.errorCoupon.status === 'FAILURE'
        ) {
            if (this.state.isHsdCustomer) {
                this.setState({
                    priceLoader: false,
                });
            }
        }

        if (
            prevOne.errorGetCustomer !== curOne.errorGetCustomer &&
            curOne.errorGetCustomer &&
            curOne.errorGetCustomer.status === 'FAILURE' &&
            curOne.errorGetCustomer.data
        ) {
            // this.props.history.push('/post-activation-home');
        }
        if (prev.checkIcc !== cur.checkIcc && cur.checkIcc && cur.checkIcc.status === 'SUCCESS' && cur.checkIcc.data) {
            this.setState({ nextClicked: false });
            if (cur.checkIcc.data && cur.checkIcc.data.isValid) {
                localStorage.setItem('simId', this.state.simNo);
                this.props.CheckoutActions.UpdateCustomerSource({
                    customerId: this.state.currentUser && this.state.currentUser.id,
                    data: { simId: this.state.simNo },
                });
                window.scroll(0, 0);
                if (userDataObj && !userDataObj.isMonthInAdvancePaid) {
                    this.setState({
                        orderSummary: true,
                    });
                } else if (secondaryCustomer && !secondaryCustomer.isMonthInAdvancePaid) {
                    this.setState({
                        orderSummary: true,
                    });
                } else {
                    this.props.changeCurrentPage('Step4');
                }
            } else {
                this.setState({ invalidSim: true });
            }
        }
        // if (prevB.config !== curB.config && curB.config && curB.config.status === 'SUCCESS' && curB.config.data) {
        //     this.setState({
        //         config: curB.config.data,
        //     });
        // }
        if (prev.errorCheckIcc !== cur.errorCheckIcc && cur.errorCheckIcc && cur.errorCheckIcc.status === 'FAILURE') {
            this.setState({ nextClicked: false });
            window.scroll(0, 0);
            store.addNotification({
                message:
                    cur.errorCheckIcc.resCode === 40153
                        ? step3 && step3.error2
                        : cur.errorCheckIcc.resCode === 40155
                        ? step3 && step3.error1
                        : activationPage && activationPage.errorDefault,
                type: 'danger',
                insert: 'top',
                container: 'top-full',
                animationIn: ['animate__animated', 'animate__fadeIn'],
                animationOut: ['animate__animated', 'animate__fadeOut'],
                dismiss: {
                    duration: 3000,
                    showIcon: true,
                },
                id: 'activationSimCardFail',
            });
        }
        if (
            prev.getCC !== cur.getCC &&
            cur.getCC &&
            cur.getCC.status === 'SUCCESS' &&
            cur.getCC.data &&
            cur.getCC.data.length > 0
        ) {
            cur.getCC.data.map((el: any) => {
                if (el.isAutoPay) {
                    this.setState({ autopayCard: el });
                    return null;
                } else {
                    return null;
                }
            });
        }
        if (
            prev.updateCCExpiry !== cur.updateCCExpiry &&
            cur.updateCCExpiry &&
            cur.updateCCExpiry.status === 'SUCCESS' &&
            cur.updateCCExpiry.data
        ) {
            this.props.ActivationActions.getCC({ customerId: this.state.user && this.state.user.id });
            window.scroll(0, 0);
            store.addNotification({
                message: 'Card expiry updated.',
                type: 'info',
                insert: 'top',
                container: 'top-full',
                animationIn: ['animate__animated', 'animate__fadeIn'],
                animationOut: ['animate__animated', 'animate__fadeOut'],
                dismiss: {
                    duration: 2000,
                    showIcon: true,
                },
                id: 'activationCardExpiryUpdated',
            });
            this.setState({
                nextClicked: false,
                updateModal: false,
                updateError: '',
                updatedExpiry: '',
                uuid: null,
            });
        }
        if (
            prev.updateCCAutoPay !== cur.updateCCAutoPay &&
            cur.updateCCAutoPay &&
            cur.updateCCAutoPay.status === 'SUCCESS' &&
            cur.updateCCAutoPay.data
        ) {
            this.setState({ nextClicked: false, setDefaultModal: false, uuid: null });
            this.props.ActivationActions.getCC({ customerId: this.state.user && this.state.user.id });
            window.scroll(0, 0);
            store.addNotification({
                message: `Card ending in ${cur.updateCCAutoPay.data &&
                    cur.updateCCAutoPay.data.ccNumberMask} is your default card!`,
                type: 'info',
                insert: 'top',
                container: 'top-full',
                animationIn: ['animate__animated', 'animate__fadeIn'],
                animationOut: ['animate__animated', 'animate__fadeOut'],
                dismiss: {
                    duration: 2000,
                    showIcon: true,
                },
                id: 'activationCardSetAsDefault',
            });
        }
        if (prev.removeCC !== cur.removeCC && cur.removeCC && cur.removeCC.status === 'SUCCESS') {
            let uuid = this.state.uuid;
            this.props.ActivationActions.getCC({ customerId: this.state.user && this.state.user.id });
            window.scroll(0, 0);
            store.addNotification({
                message: `Card ending in ${uuid && uuid.ccNumberMask} deleted successfully!`,
                type: 'info',
                insert: 'top',
                container: 'top-full',
                animationIn: ['animate__animated', 'animate__fadeIn'],
                animationOut: ['animate__animated', 'animate__fadeOut'],
                dismiss: {
                    duration: 2000,
                    showIcon: true,
                },
                id: 'activationCardDeleted',
            });
            this.setState({ nextClicked: false, removeModal: false, uuid: null });
        }
        if (prev.ccHold !== cur.ccHold && cur.ccHold && cur.ccHold.status === 'SUCCESS' && cur.ccHold.data) {
            if (cur.ccHold.data.holdStatus) {
                localStorage.setItem('card_hold', 'true');
                this.setState({ nextClicked: false, simModal: false });
                this.props.changeCurrentPage('Step4');
            } else {
                this.setState({
                    activationPause: true,
                    activationPauseAmount: `Your activation is paused as we are unable to place a hold for ${cur.ccHold
                        .data && cur.ccHold.data.amount} on
                    your card. To complete activation, please enter new card details.`,
                    nextClicked: false,
                    simModal: false,
                });
            }
        }
        if (prev.errorCCHold !== cur.errorCCHold && cur.errorCCHold && cur.errorCCHold.status === 'FAILURE') {
            if (cur.errorCCHold && cur.errorCCHold.resCode === 40224) {
                localStorage.setItem('card_hold', 'true');
                this.setState({ nextClicked: false, simModal: false });
                this.props.changeCurrentPage('Step4');
            } else {
                window.scroll(0, 0);
                store.addNotification({
                    message: cur.errorCCHold && cur.errorCCHold.message,
                    type: 'danger',
                    insert: 'top',
                    container: 'top-full',
                    animationIn: ['animate__animated', 'animate__fadeIn'],
                    animationOut: ['animate__animated', 'animate__fadeOut'],
                    dismiss: {
                        duration: 3000,
                        showIcon: true,
                    },
                    id: 'activationCardHoldFail',
                });
                this.setState({
                    activationPause: true,
                    activationPauseAmount:
                        'Your activation is paused as we are unable to place a hold on your card. To complete activation, please enter new card details.',
                    nextClicked: false,
                    simModal: false,
                });
            }
        }
        if (
            prev.errorUpdateCCAutoPay !== cur.errorUpdateCCAutoPay &&
            cur.errorUpdateCCAutoPay &&
            cur.errorUpdateCCAutoPay.status === 'FAILURE'
        ) {
            window.scroll(0, 0);
            store.addNotification({
                message: cur.errorUpdateCCAutoPay && cur.errorUpdateCCAutoPay.message,
                type: 'danger',
                insert: 'top',
                container: 'top-full',
                animationIn: ['animate__animated', 'animate__fadeIn'],
                animationOut: ['animate__animated', 'animate__fadeOut'],
                dismiss: {
                    duration: 3000,
                    showIcon: true,
                },
                id: 'activationCardAutopayFail',
            });
            this.setState({ nextClicked: false, setDefaultModal: false, uuid: null });
        }
        if (prev.errorRemoveCC !== cur.errorRemoveCC && cur.errorRemoveCC && cur.errorRemoveCC.status === 'FAILURE') {
            window.scroll(0, 0);
            store.addNotification({
                message: cur.errorRemoveCC && cur.errorRemoveCC.message,
                type: 'danger',
                insert: 'top',
                container: 'top-full',
                animationIn: ['animate__animated', 'animate__fadeIn'],
                animationOut: ['animate__animated', 'animate__fadeOut'],
                dismiss: {
                    duration: 3000,
                    showIcon: true,
                },
                id: 'activationCardRemoveFail',
            });
            this.setState({ nextClicked: false, removeModal: false, uuid: null });
        }

        const prevCheck = prevProps && prevProps.CheckoutState;
        const curCheck = this.props && this.props.CheckoutState;
        if (
            prevCheck.payment !== curCheck.payment &&
            curCheck.payment &&
            curCheck.payment.status === 'SUCCESS' &&
            curCheck.payment.data &&
            curCheck.payment.data.id
        ) {
            this.props.CheckoutActions.PaymentGet({
                id: curCheck.payment.data.id,
            });
            window.location.href = `https://ruezvc6iie.execute-api.us-east-1.amazonaws.com/Prod/v0/account/redirect/page/${curCheck.payment.data.id}`;
        }

        if (
            prev.monthInAdvance !== cur.monthInAdvance &&
            cur.monthInAdvance &&
            (cur.monthInAdvance.totalTax || cur.monthInAdvance.totalTax === 0) &&
            (cur.monthInAdvance.amount || cur.monthInAdvance.amount === 0)
        ) {
            this.setState({
                amount: {
                    totalAmount: cur.monthInAdvance.amount,
                    taxes: cur.monthInAdvance.totalTax,
                },
                modalLoading: false,
            });
        }

        if (
            prev.errorMonthInAdvance !== cur.errorMonthInAdvance &&
            cur.errorMonthInAdvance &&
            cur.errorMonthInAdvance.status === 'FAILURE'
        ) {
            this.setState({ payNowModal: false });
            window.scroll(0, 0);
            store.addNotification({
                // title: 'Error',
                message: activationPage.errorDefault,
                type: 'danger',
                insert: 'top',
                container: 'top-full',
                animationIn: ['animate__animated', 'animate__fadeIn'],
                animationOut: ['animate__animated', 'animate__fadeOut'],
                dismiss: {
                    duration: 3000,
                    showIcon: true,
                },
                id: 'activationDefaultError',
            });
        }

        if (
            prev.errorMonthInAdvancePost !== cur.errorMonthInAdvancePost &&
            cur.errorMonthInAdvancePost &&
            cur.errorMonthInAdvancePost.status === 'FAILURE'
        ) {
            if (cur.errorMonthInAdvancePost.resCode && cur.errorMonthInAdvancePost.resCode === 40020) {
                this.setState({
                    confirmClicked: false,
                    payNowSuccess: false,
                    buttonLoading: false,
                    payNowModal: false,
                    payNowFail: false,
                });

                //set secondary user localstorage month in advance to true
                let secondaryUser: any = localStorage.getItem('secondaryCustomerDetail');
                secondaryUser = JSON.parse(secondaryUser);
                if (secondaryUser) {
                    localStorage.setItem(
                        'secondaryCustomerDetail',
                        JSON.stringify({ ...secondaryUser, isMonthInAdvancePaid: true }),
                    );
                }

                let currentdetails: any = localStorage.getItem('customerDetail');
                currentdetails = JSON.parse(currentdetails);
                if (currentdetails) {
                    localStorage.setItem(
                        'customerDetail',
                        JSON.stringify({ ...currentdetails, isMonthInAdvancePaid: true }),
                    );
                }
            } else {
                this.setState({
                    buttonLoading: false,
                    payNowFail: true,
                    payNowModal: false,
                });
            }
        }
        if (
            prev.monthInAdvancePost !== cur.monthInAdvancePost &&
            cur.monthInAdvancePost &&
            cur.monthInAdvancePost.status === 'SUCCESS' &&
            cur.monthInAdvancePost.data.amount
        ) {
            this.setState({
                payNowModal: false,
            });
            if (this.state.confirmClicked) {
                this.setState({
                    confirmClicked: false,
                    payNowSuccess: false,
                });
            }
            if (this.state.eSim) {
                this.activateHandler();
            } else {
                this.props.changeCurrentPage('Step4');
            }
        }
        if (this.state.kitSent) {
            store.addNotification({
                message: `You're line is activated and your digital Activation Kit will reach your inbox on ${this.state.currentUser?.emailId}`,
                type: 'info',
                insert: 'top',
                container: 'top-full',
                animationIn: ['animate__animated', 'animate__fadeIn'],
                animationOut: ['animate__animated', 'animate__fadeOut'],
                dismiss: {
                    duration: 5000,
                    showIcon: true,
                },
                id: 'sendKitSuccess',
            });
        }

        const { currentUser } = this.state;
        if (prev.activation !== cur.activation && cur.activation && cur.activation.status === 'SUCCESS') {
            if (this.state.fromPorting !== true) {
                this.setState({ actInProgress: true });
                this.props.ActivationActions.activationStatus({ customerId: currentUser && currentUser.id });
            } else {
                // this.setState({ isPortingCase: true, portInProgress: true })
                this.props.history.push({
                    pathname: '/status',
                    state: {
                        portInProgress: true,
                        user: currentUser,
                    },
                });
            }
            this.setState({ loader: false, orderSummary: false });
        }

        if (
            prev.errorActivation !== cur.errorActivation &&
            cur.errorActivation &&
            cur.errorActivation.status === 'FAILURE'
        ) {
            if (this.state.fromPorting === true) {
                // this.setState({ isPortingCase: true, genericErr: true })
                this.props.history.push({
                    pathname: '/status',
                    state: {
                        genericErr: true,
                        user: currentUser,
                    },
                });
            } else if (cur.errorActivation.resCode === 40624) {
                this.props.history.push('/activation-error');
            } else if (cur.errorActivation.resCode === 40622) {
                this.setState({ isActivationGenericErr: true });
            } else {
                this.setState({
                    actFailed: true,
                    actInProgress: false,
                });
            }
            this.setState({ loader: false, orderSummary: false });
        }
        if (
            prev.errorActivationStatus !== cur.errorActivationStatus &&
            cur.errorActivationStatus &&
            cur.errorActivationStatus.status === 'FAILURE'
        ) {
            setTimeout(() => {
                this.props.ActivationActions.activationStatus({
                    customerId: currentUser && currentUser.id,
                });
            }, 5000);
        }

        if (
            prev.activationStatus !== cur.activationStatus &&
            cur.activationStatus &&
            cur.activationStatus.status === 'SUCCESS' &&
            cur.activationStatus.data
        ) {
            let status = cur.activationStatus.data;
            // let customerDetail: any = localStorage.getItem('customerDetail');
            // customerDetail = JSON.parse(customerDetail);
            if (status && (status.status === 1 || status.status === 9)) {
                setTimeout(() => {
                    this.props.ActivationActions.activationStatus({
                        customerId: currentUser && currentUser.id,
                    });
                }, 5000);
            } else {
                // this.props.CheckoutActions.GetCustomer({
                //     username: encodeURIComponent(customerDetail && customerDetail.emailId),
                // });
                if (status && status.status === 2 && currentUser?.esim && !currentUser?.eSimSetup) {
                    if (this.state.fromPorting !== true) {
                        this.setState({ actSuccess: true, actInProgress: false });
                    }
                    this.setState({ actSuccess: true, actInProgress: false });
                }
                if (status && status.password) {
                    this.setState({
                        statusPassword: status.password,
                    });
                }
                if (status?.status === 10) {
                    // this.setState({
                    //     isPortFailed: true
                    // })
                }
            }
        }
    }

    onChangeHandler = async (e: any, type: string) => {
        if (type === 'simNo') {
            this.setState({ simNo: e.target.value, error: false });
        }
        if (type === 'UpdateExpiry') {
            let val;
            if (/^[0-9/]+$/.test(e.target.value) || e.target.value === '') {
                val =
                    e.target.value.length > 2 && /^[0-9]+$/.test(e.target.value)
                        ? e.target.value.slice(0, 2) + '/' + e.target.value.slice(2)
                        : e.target.value;
                await this.setState({
                    updatedExpiry: val,
                });
                this.validateCardExpiry();
            }
        }
    };
    validateCardExpiry = () => {
        let date: string = this.state.updatedExpiry && this.state.updatedExpiry.replace(/[^0-9]/, '');
        if (date.length === 4) {
            let message = '';
            let month = parseInt(date && date.slice(0, 2));
            let year = parseInt(date && date.slice(2));
            let currentMonth = new Date().getMonth() + 1;
            let currentYear = parseInt(
                new Date()
                    .getFullYear()
                    .toString()
                    .substr(-2),
            );
            if ((year === currentYear && month <= currentMonth) || year < currentYear)
                message = 'Please enter a correct year.';
            else if (month < 1 || month > 12) message = 'Please enter a correct month.';

            this.setState({ updateError: message });
        }
    };
    nextHandler = () => {
        let secondaryCustomer: any = localStorage.getItem('secondaryCustomerDetail');
        // pushTrackingEventsToGAAndFB({
        //     category: 'Activation',
        //     actionType: 'Activation SIM Check',
        //     label: '',
        // });
        secondaryCustomer = JSON.parse(secondaryCustomer);
        this.setState({ nextClicked: true });
        isPaymentEnabled && this.props.ActivationActions.monthInAdvancePostFailureReset({});
        this.props.ActivationActions.checkIcc({
            customerId: this.state.currentUser && this.state.currentUser.id,
            iccid: this.state.simNo,
        });
    };
    updateSubmitHandler = () => {
        if (
            this.state.updateError === '' &&
            this.state.updatedExpiry &&
            this.state.updatedExpiry &&
            this.state.updatedExpiry.replace(/[^0-9]/, '').length === 4 &&
            this.state.uuid
        ) {
            this.setState({ nextClicked: true });
            isPaymentEnabled &&
                this.props.ActivationActions.updateCCExpiry({
                    uuid: this.state.uuid && this.state.uuid.uuid,
                    expiry: this.state.updatedExpiry && this.state.updatedExpiry.replace(/[^0-9]/, ''),
                });
        }
    };
    setDefaultSubmitHandler = () => {
        this.setState({ nextClicked: true });
        isPaymentEnabled &&
            this.props.ActivationActions.updateCCAutoPay({ uuid: this.state.uuid && this.state.uuid.uuid });
    };
    removeSubmitHandler = () => {
        this.setState({ nextClicked: true });
        isPaymentEnabled && this.props.ActivationActions.removeCC({ uuid: this.state.uuid && this.state.uuid.uuid });
    };
    confirmHandler = () => {
        this.setState({ nextClicked: true });
        isPaymentEnabled &&
            this.props.ActivationActions.ccHold({
                customerId: this.state.user && this.state.user.id,
            });
    };
    onChangeCardHandler = () => {
        localStorage.setItem('manageCard', 'true');
        this.setState({
            simModal: false,
            changeCard: true,
            activationPause: false,
            activationPauseAmount: null,
        });
    };
    addNewCardHandler = () => {
        localStorage.setItem('manageCard', 'true');
        if (this.formRef.current) {
            this.formRef.current.submit();
        }
    };
    updateCardHandler = (data: any) => {
        this.setState({
            uuid: data,
            updateModal: true,
            updatedExpiry: `${data && data.dateOfExpiry && data.dateOfExpiry.slice(0, 2)}/${data &&
                data.dateOfExpiry &&
                data.dateOfExpiry.slice(2)}`,
        });
    };
    removeCardHandler = (data: any) => {
        this.setState({ uuid: data, removeModal: true });
    };
    setDefaultCardHandler = (data: any) => {
        this.setState({ uuid: data, setDefaultModal: true });
    };
    backHandler = () => {
        const manageCard = localStorage.getItem('manageCard');
        if (manageCard === 'true') {
            this.props.changeCurrentPage('Step3');
            this.setState({ changeCard: false });
            localStorage.setItem('manageCard', 'false');
        }
        // else if (this.state.showPayNow) {
        //     this.props.changeCurrentPage('Step3');
        //     this.setState({
        //         showPayNow: false
        //     })
        // }
        else {
            this.props.changeCurrentPage('Step2');
        }
        store.removeNotification('activatedEsimNoti');
    };

    getCardImage = (cardType?: string) => {
        return cardType && cardImages[cardType?.toUpperCase()];
    };
    confirmOrderSummary = () => {
        this.setState({
            orderSummary: false,
        });
        this.props.changeCurrentPage('Step4');
        TagManager.dataLayer({
            dataLayer: {
                event: 'Confirm',
            },
        });
        // this.GAAndFBEventsHandler('Confirm');
    };
    payNowSuccessHandler = () => {
        // pushTrackingEventsToGAAndFB({
        //     category: 'Activation',
        //     actionType: 'pay now success',
        //     label: '',
        // });
        this.setState({
            payNowSuccess: false,
        });
        if (!this.state.eSim) {
            this.props.changeCurrentPage('Step4');
        }

        let currentdetails: any = localStorage.getItem('customerDetail');
        currentdetails = JSON.parse(currentdetails);
        let secondaryUser: any = localStorage.getItem('secondaryCustomerDetail');
        secondaryUser = JSON.parse(secondaryUser);

        if (secondaryUser) {
            localStorage.setItem(
                'secondaryCustomerDetail',
                JSON.stringify({ ...secondaryUser, isMonthInAdvancePaid: true }),
            );
        }
        if (currentdetails) {
            localStorage.setItem('customerDetail', JSON.stringify({ ...currentdetails, isMonthInAdvancePaid: true }));
        }
    };

    letGoHandler = () => {
        // pushTrackingEventsToGAAndFB({
        //     category: 'Activation',
        //     actionType: 'Lets Go',
        //     label: '',
        // });
        this.setState({
            mainPageModal: false,
            buttonLoading: false,
        });
    };

    payNowFailHandler = () => {
        // pushTrackingEventsToGAAndFB({
        //     category: 'Activation',
        //     actionType: 'pay now fail',
        //     label: '',
        // });
        this.setState({ payNowFail: false });
        this.payNowConfirm();
    };
    activateHandler = () => {
        this.setState({ loader: true });
        const { user, currentUser } = this.state;
        let sim = localStorage.getItem('simId');
        let simId = sim ? sim : '';
        let secondaryCustomer: any = localStorage.getItem('secondaryCustomerDetail');
        secondaryCustomer = JSON.parse(secondaryCustomer);
        TagManager.dataLayer({
            dataLayer: {
                event: 'Confirm',
            },
        });
        // this.GAAndFBEventsHandler('Confirm');
        let payload: any;
        if (this.state.eSim) {
            payload = {
                esim: secondaryCustomer ? secondaryCustomer.esim : user.esim,
                customerId: secondaryCustomer ? secondaryCustomer.id : user.id,
                reachPlanId: secondaryCustomer ? secondaryCustomer.reachPlanId : user && user.reachPlanId,
                iccId: simId ? simId : user.simId,
                imei: secondaryCustomer ? secondaryCustomer.imei : user.imei,
                make: secondaryCustomer ? secondaryCustomer.make : user.make,
                model: secondaryCustomer ? secondaryCustomer.model : user.model,
                skipHold: true,
            };
            if (currentUser && currentUser.isMNP) {
                payload.isPort = true;
                payload.numberToPort = currentUser?.mnpInfo?.oldNumber.replace(/(\D)/g, '');
                payload.oldCarrier = currentUser?.mnpInfo?.operator;
                payload.oldCarrierAccountNumber = currentUser?.mnpInfo?.acctNum;
                payload.password = currentUser?.mnpInfo?.oldPassword;
                payload.oldZip = currentUser?.mnpInfo?.oldZip;
            }
            this.props.ActivationActions.activation(payload);
        } else {
            payload = {
                customerId: secondaryCustomer ? secondaryCustomer.id : user.id,
                reachPlanId: secondaryCustomer ? secondaryCustomer.reachPlanId : user.reachPlanId,
                iccId: simId ? simId : user.simId,
                imei: secondaryCustomer ? secondaryCustomer.imei : user.imei,
                make: secondaryCustomer ? secondaryCustomer.make : user.make,
                model: secondaryCustomer ? secondaryCustomer.model : user.model,
                skipHold: true,
            };
            if (currentUser && currentUser.isMNP) {
                payload.isPort = true;
                payload.numberToPort = currentUser?.mnpInfo?.oldNumber.replace(/(\D)/g, '');
                payload.oldCarrier = currentUser?.mnpInfo?.operator;
                payload.oldCarrierAccountNumber = currentUser?.mnpInfo?.acctNum;
                payload.password = currentUser?.mnpInfo?.oldPassword;
                payload.oldZip = currentUser?.mnpInfo?.oldZip;
            }
            this.props.ActivationActions.activation(payload);
        }
    };

    payNowConfirm = () => {
        let user1: any = localStorage.getItem('currentuser');
        const currentdetails: any = localStorage.getItem('customerDetail');
        const customerDetails = JSON.parse(currentdetails);
        let secondaryCustomer: any = localStorage.getItem('secondaryCustomerDetail');
        secondaryCustomer = JSON.parse(secondaryCustomer);
        user1 = JSON.parse(user1);

        let email: string = user1 && user1.email ? user1.email : '';
        this.setState({
            email: email,
            buttonLoading: true,
        });

        const cusId = secondaryCustomer ? secondaryCustomer.id : customerDetails && customerDetails.id;
        isPaymentEnabled &&
            this.props.ActivationActions.monthInAdvancePost({
                customerId: cusId,
            });
        this.setState({
            confirmClicked: true,
        });
    };
    continueHandler = () => {
        this.props.history.push({
            pathname: '/home',
            state: {
                eSim: true,
            },
        });
    };
    resendHandler = () => {
        this.setState({ resendModal: true });
    };
    sendKit = () => {
        this.setState({ resendModal: false });
        this.setState({ kitSent: true });
        setTimeout(() => {
            this.setState({ kitSent: false });
        }, 500);
    };
    onHide = () => {
        if (this.state.showSetupProfileModal) {
            this.setState({ showSetupProfileModal: false });
        }
    };
    paymentSuccessModal = () => {
        this.setState({ paymentSuccessModal: true });
    };

    handlePlanPrice = (plan: any) => {
        let line: any;
        let lineNumber: any = localStorage.getItem('lineNumber');
        lineNumber = JSON.parse(lineNumber);
        let numOfLines: any = localStorage.getItem('numOfLines');
        numOfLines = JSON.parse(numOfLines);
        if (lineNumber) {
            line = lineNumber;
        } else {
            line = numOfLines;
        }

        if (!plan.addLineSplitPrice) {
            return plan.baseLinePrice + (line - 1) * plan.additionalLinePrice;
        } else {
            const addLinePrice = plan.addLineSplitPrice;
            if (line > 1) {
                // let secondaryCustomer: any = localStorage.getItem('secondaryCustomerDetail');
                // secondaryCustomer = JSON.parse(secondaryCustomer);
                // let occurence = secondaryCustomer.peerAccountRef.split('|')[2];
                return addLinePrice[line - 1];
            } else {
                return plan.baseLinePrice;
            }
        }
    };

    handleGenericErrorCTA = () => {
        this.setState({ isActivationGenericErr: false, orderSummary: true });
    };

    render() {
        let secondaryUser: any = localStorage.getItem('secondaryCustomerDetail');
        secondaryUser = JSON.parse(secondaryUser);
        let customerDetail: any = localStorage.getItem('customerDetail');
        customerDetail = JSON.parse(customerDetail);
        let step3 = activationPage && activationPage.step3;
        const {
            simNo,
            nextClicked,
            error,
            simModal,
            changeCard,
            orderSummary,
            actFailed,
            actInProgress,
            actSuccess,
            invalidSim,
            isActivationGenericErr,
        } = this.state;
        const cards =
            isPaymentEnabled &&
            this.props.ActivationState &&
            this.props.ActivationState.getCC &&
            this.props.ActivationState.getCC.status === 'SUCCESS' &&
            this.props.ActivationState.getCC.data;

        let currentPlan: any = null;
        currentPlan = localStorage.getItem('currentPlan');
        currentPlan = JSON.parse(currentPlan);

        if (currentPlan === null) {
            currentPlan = localStorage.getItem('reachSelectedPlanDetail');
            currentPlan = JSON.parse(currentPlan);
            currentPlan = currentPlan.plan;
        }
        // const currentPlanPrice = this.handlePlanPrice(currentPlan);
        return (
            <div className="step3ActivationMain">
                <>
                    <form
                        ref={this.formRef}
                        method="post"
                        name="addCardForm"
                        id="addCardForm"
                        action={process.env.REACT_APP_ADD_CARD_ADDRESS}
                    >
                        <input
                            type="hidden"
                            name="emailId"
                            value={this.state?.user?.emailId ? this.state.user.emailId : ''}
                        />
                        <input type="hidden" name="redirectUrl" value={`${window.location.origin}/activation`} />
                    </form>
                </>
                {changeCard ? (
                    <>
                        <img src={BackButton} alt="back" className="arrow_icon" onClick={this.backHandler} />
                        <div className="changeCardStep3">
                            <div className="changeCardTitle">Manage card(s)</div>
                            <div className="step3MangeCardLine"></div>
                            <div className="savedCardsDetails">Saved cards</div>
                            {cards.length > 0 &&
                                cards.map((el: any, index: number) => {
                                    if (el && el.isAutoPay) {
                                        return (
                                            <div key={index}>
                                                <div className="activation-border-line"></div>
                                                <div className="cardstep3Data">
                                                    <div className="cardData">
                                                        <div className="imageCardDetail">
                                                            <img
                                                                src={
                                                                    el && el.type === 'VISA'
                                                                        ? VisaIcon
                                                                        : AmericanExpress
                                                                }
                                                                alt=""
                                                            />
                                                        </div>
                                                        <div className="cardDetailsArea">
                                                            <div className="cardNumber">
                                                                XXXX-XXXX-XXXX-{el && el.ccNumberMask}
                                                            </div>
                                                            <div className="cardNameExp">
                                                                {el && el.nameOnCard} | Expiration date{' '}
                                                                {el && el.dateOfExpiry && el.dateOfExpiry.slice(0, 2)}/
                                                                {el && el.dateOfExpiry && el.dateOfExpiry.slice(2)}
                                                            </div>
                                                            <div className="cardActions">
                                                                <div
                                                                    className="cardAction1"
                                                                    onClick={() => this.updateCardHandler(el)}
                                                                >
                                                                    Update
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    {el && el.isAutoPay && (
                                                        <div className="tickMarkCardStep3">
                                                            <img src={TickMark} alt="" />
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        );
                                    } else {
                                        return null;
                                    }
                                })}
                            {cards.length > 0 &&
                                cards.map((el: any, index: number) => {
                                    if (!(el && el.isAutoPay)) {
                                        return (
                                            <div key={index}>
                                                <div className="activation-border-line"></div>
                                                <div className="cardstep3Data">
                                                    <div className="cardData">
                                                        <div className="imageCardDetail">
                                                            <img
                                                                src={
                                                                    el && el.type === 'VISA'
                                                                        ? VisaIcon
                                                                        : AmericanExpress
                                                                }
                                                                alt=""
                                                            />
                                                        </div>
                                                        <div className="cardDetailsArea">
                                                            <div className="cardNumber">
                                                                XXXX-XXXX-XXXX-{el && el.ccNumberMask}
                                                            </div>
                                                            <div className="cardNameExp">
                                                                {el && el.nameOnCard} | Expiration date{' '}
                                                                {el && el.dateOfExpiry && el.dateOfExpiry.slice(0, 2)}/
                                                                {el && el.dateOfExpiry && el.dateOfExpiry.slice(2)}
                                                            </div>
                                                            <div className="cardActions">
                                                                <div
                                                                    className="cardAction1"
                                                                    onClick={() => this.setDefaultCardHandler(el)}
                                                                >
                                                                    Set as default
                                                                </div>
                                                                <div
                                                                    className="cardAction1"
                                                                    onClick={() => this.updateCardHandler(el)}
                                                                >
                                                                    Update
                                                                </div>
                                                                <div
                                                                    className="cardAction1"
                                                                    onClick={() => this.removeCardHandler(el)}
                                                                >
                                                                    Remove
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        );
                                    } else {
                                        return null;
                                    }
                                })}
                            <div className="activation-border-line"></div>
                            <div className="addMoreCardBtnsStep3">
                                <Button onClick={this.addNewCardHandler}>
                                    <AddIcon />
                                    Add a new card
                                </Button>
                            </div>
                            <div className="backToActivation" onClick={this.backHandler}>
                                Back to activation
                            </div>
                        </div>
                    </>
                ) : this.state.eSim && !orderSummary ? (
                    <div style={{ marginBottom: '100px' }}>
                        {isActivationGenericErr ? (
                            <GenericError handleGenericErrorCTA={this.handleGenericErrorCTA} />
                        ) : actFailed ? (
                            <div className="activationStatus">
                                <img src={failedIcon} />
                                <div className="activationStatusTitle">Activation Failed</div>
                                <div className="activationStatusSubtitle">
                                    Sorry, we couldn't complete line activation for {getUserName()} due to an unexpected
                                    error.
                                </div>
                                <div className="backToHome">
                                    <Button
                                        primary={true}
                                        onClick={() => this.props.history.push('/post-activation-home')}
                                    >
                                        Back to home
                                    </Button>
                                </div>
                            </div>
                        ) : actInProgress ? (
                            <div className="activationStatus">
                                <img src={inProgressIcon} />
                                <div className="activationStatusTitle">Activation in Progress</div>
                                <div className="activationStatusSubtitle">
                                    Activation for {getUserName()}'s line has begun. Please click the green 'Continue to
                                    Home' button to monitor the activation progress. We will let you know once the
                                    activation process is complete.
                                </div>
                                <div className="backToHomeBtn">
                                    <Button
                                        primary={true}
                                        onClick={() => this.props.history.push('/post-activation-home')}
                                    >
                                        Continue To Home
                                    </Button>
                                </div>
                            </div>
                        ) : actSuccess ? (
                            <div className="activationStatus">
                                <img src={successIcon} />
                                <div className="activationStatusTitle">Activation Successful</div>
                                <div className="activationStatusSubtitle">
                                    Congratulations! {getUserName()}'s line has been successfully activated.
                                    <br />
                                    You can now enjoy all the features and benefits of our eSIM services.
                                </div>
                                {/* <Button primary={true} onClick={() => this.props.changeCurrentPage('Step4')}> */}
                                <Button
                                    primary={true}
                                    onClick={() => {
                                        this.props.history.push('/steps');
                                        TagManager.dataLayer({
                                            dataLayer: {
                                                event: 'ContinueSetup',
                                            },
                                        });
                                        // this.GAAndFBEventsHandler('ContinueSetup');
                                    }}
                                >
                                    CONTINUE TO SETUP
                                </Button>
                            </div>
                        ) : null}
                    </div>
                ) : orderSummary ? (
                    <div className="orderSummary">
                        <div className="backButtonActivation">
                            <img src={BackButton} alt="back" className="arrow_icon" onClick={this.backHandler} />
                            <div className="titleMainActivation">{step3?.orderSummaryModal?.title}</div>
                        </div>
                        <div className="summary">
                            {
                                // ----------cumulative changes---------------
                                /* {this.state.isSecondaryCust && (
                                <div className="planInfoTitle">
                                    <div>Plan: {currentPlan?.name}</div>
                                </div>
                            )} */
                            }

                            {/* {this.state.isSecondaryCust ? 
                            (
                                <div className="planInfo">
                                    <div className="planName">
                                        Additional for{' '}
                                        {secondaryUser ? secondaryUser?.firstName : customerDetail?.firstName}'s line
                                    </div>
                                    {!this.state.priceLoader ? (
                                        <div className="planPrice">
                                            $
                                            {(() => {
                                                const price = currentPlanPrice - this.state.hsdDiscount;
                                                const formattedPrice = price.toFixed(2);
                                                return formattedPrice < '0' ? '0.00' : formattedPrice;
                                            })()}
                                            /mo.
                                        </div>
                                    ) : (
                                        <Skeleton className="skeletonRadius" />
                                    )}
                                </div>
                            ) : ( */}
                            <div className="planInfo">
                                <div className="planName" style={{ textAlign: 'center', fontSize: '24px' }}>
                                    {currentPlan?.name} Mobile Plan
                                </div>
                                {/* {!this.state.priceLoader ? (
                                    <div className="planPrice">
                                        $
                                        {(() => {
                                            const price = currentPlanPrice - this.state.hsdDiscount;
                                            const formattedPrice = price.toFixed(2);
                                            return formattedPrice < '0' ? '0.00' : formattedPrice;
                                        })()}
                                        /mo.
                                    </div>
                                ) : (
                                    <Skeleton className="skeletonRadius" />
                                )} */}
                            </div>

                            {
                                // ----------cumulative changes---------------
                                /* {this.state.isSecondaryCust && <div className="line"></div>} */
                            }
                            {/* {this.state.isSecondaryCust ? (
                                <div className="planInfo">
                                    <div className="planName">Total</div>
                                    {!this.state.priceLoader ? (
                                        <div className="planPrice">
                                            $
                                            {
                                            (() => {
                                                const price =
                                                    this.state.setExistingPrice -
                                                    this.state.totalActiveLines * this.state.hsdDiscount +
                                                    (currentPlanPrice - this.state.hsdDiscount);
                                                const formattedPrice = price.toFixed(2);
                                                return formattedPrice < '0' ? '0.00' : formattedPrice;
                                            })()}
                                            /mo.
                                        </div>
                                    ) : (
                                        <Skeleton className="skeletonRadius" />
                                    )}
                                </div>
                            ) : (
                                ''
                            )} */}
                            {/* <div className="note">({step3?.orderSummaryModal?.subtext})</div> */}
                            <div className="line"></div>
                            <div className="info">{step3?.orderSummaryModal?.note}</div>
                            <div
                                className="terms"
                                onClick={() => {
                                    window.open(process.env.REACT_APP_ASTOUND_TERMS_AND_CONDITIONS_URL);
                                }}
                            >
                                TERMS & CONDITIONS
                            </div>
                        </div>
                        <div className="summaryConfirmBtn">
                            <Button
                                primary={true}
                                onClick={
                                    this.state.eSim && !this.state.loader
                                        ? this.activateHandler
                                        : !this.state.loader
                                        ? this.confirmOrderSummary
                                        : () => {}
                                }
                                disabled={this.state.priceLoader}
                            >
                                {this.state.loader && this.state.eSim ? (
                                    <div className="loaderCheck text-center">
                                        <CircularProgress />
                                    </div>
                                ) : (
                                    'Confirm'
                                )}
                            </Button>
                        </div>
                    </div>
                ) : invalidSim ? (
                    <div>
                        <div className="backButtonActivation">
                            <img src={BackButton} alt="back" className="arrow_icon" onClick={this.backHandler} />
                        </div>
                        <div className="invalid">
                            <img src={failedIcon} />
                            <div className="invalidTitle">Invalid SIM Number</div>
                            <div className="invalidSubtitle">
                                The SIM number you entered isn't valid. Please enter a valid SIM number to proceed.
                            </div>
                            <div className="invalidBtn">
                                <Button primary={true} onClick={() => this.setState({ invalidSim: false })}>
                                    RETRY
                                </Button>
                            </div>
                        </div>
                    </div>
                ) : (
                    <div>
                        <div className="backButtonActivation">
                            <img src={BackButton} alt="back" className="arrow_icon" onClick={this.backHandler} />
                            <div className="titleMainActivation">
                                {changeCard
                                    ? step3 && step3.manageCard && step3.manageCard.title
                                    : step3 && step3.title}
                            </div>
                        </div>
                        {!orderSummary && (
                            <div className="ProgressBarActivation">
                                <div className="stepsCount">Step 3 of 4</div>
                                <ProgressBar variant="success" now={75} className="progressBar" />
                            </div>
                        )}
                        <div className="step3Activation">
                            <div
                                className="mainCardStep3"
                                onKeyPress={(e: any) => {
                                    if (e.key === 'Enter' && simNo.toString().length === 20) {
                                        this.nextHandler();
                                    }
                                }}
                            >
                                <div className="step3MainText">{step3 && step3.cardText}</div>
                                <div className="simImgContaineriPad">
                                    <img src={simImage} alt="simImage" />
                                    <div className="simText">
                                        You can find your <strong>SIM number</strong> on the back of your SIM card.
                                    </div>
                                </div>
                                <div className="step3TextField">
                                    <div className="inputFieldLabel">
                                        SIM NUMBER
                                        <span className="iBtn">
                                            <div className="simImgContainer">
                                                <div className="simText">
                                                    You can find your <strong>SIM number</strong> on the back of your
                                                    SIM card.
                                                </div>
                                                <img src={simImage} alt="simImage" />
                                                <div className="bottom-arrow"></div>
                                            </div>
                                            <img src={infoIcon} alt="info" />
                                        </span>
                                    </div>
                                    <TextField
                                        value={simNo}
                                        type={window.screen.width <= 600 ? 'number' : 'text'}
                                        maxlength={19}
                                        onChange={(e: any) => {
                                            if (
                                                (/^[0-9]+$/.test(e.target.value) || e.target.value === '') &&
                                                e.target.value.length <= 19
                                            ) {
                                                this.onChangeHandler(e, 'simNo');
                                            }
                                        }}
                                        onBlur={() => this.setState({ error: true })}
                                    />
                                    <div className="messageText">
                                        {error ? (
                                            <div className="errorMsg">
                                                {simNo === ''
                                                    ? 'SIM number cannot be empty'
                                                    : simNo !== '' && simNo.length !== 19
                                                    ? 'This must be 19 characters long.'
                                                    : ''}
                                            </div>
                                        ) : (
                                            <div></div>
                                        )}
                                        <div className="countDiv">{simNo.length}/19</div>
                                    </div>
                                </div>
                                <div className="nextButtonStep3">
                                    <Button
                                        primary={true}
                                        onClick={!nextClicked ? this.nextHandler : () => {}}
                                        disabled={simNo.length < 19 ? true : false}
                                    >
                                        {nextClicked && !simModal ? (
                                            <div className="loaderCheck text-center">
                                                <CircularProgress />
                                            </div>
                                        ) : (
                                            'Next'
                                        )}
                                    </Button>
                                </div>
                                {/* <div className="nextButtonStep3">
                                        {nextClicked && !simModal ? (
                                            <div className="loaderCheck text-center">
                                                <CircularProgress />
                                            </div>
                                        ) : (
                                            <Button
                                                primary={true}
                                                onClick={this.nextHandler}
                                                disabled={simNo.length < 19 ? true : false}
                                            >
                                                Next
                                            </Button>
                                        )}
                                    </div> */}
                            </div>
                        </div>
                    </div>
                )}
                {this.state.showSetupProfileModal && (
                    <SetupProfileSteps
                        showSetupProfileModal={this.state.showSetupProfileModal}
                        onHide={this.onHide}
                        ios={this.state.ios}
                        android={this.state.android}
                    />
                )}
            </div>
        );
    }
}

function mapDispatchToProps(dispatch: any) {
    return {
        HomeActions: bindActionCreators(HomeAction, dispatch),
        ActivationActions: bindActionCreators(ActivationAction, dispatch),
        CheckoutActions: bindActionCreators(Action, dispatch),
        BillingActions: bindActionCreators(BillingAction, dispatch),
        TrackOrderActions: bindActionCreators(TrackOrderAction, dispatch),
    };
}

const mapStateToProps = (state: any) => ({
    ActivationState: state.activation,
    CheckoutState: state.checkout,
    BillingState: state.billing,
    HomeState: state.home,
    PostActivationState: state.postActivation,
    TrackOrderState: state.trackOrder,
});

export default connect(mapStateToProps, mapDispatchToProps)(Step3);
